import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
export const TomosSection = memo(function TomosSection() {
  const tomos = [{
    icon: '⚡',
    title: 'Tomo 1 — Fundamentos y Seguridad',
    subtitle: 'El miedo a los cables se termina en la primera página.',
    desc: 'Entendés cómo funciona la electricidad de tu casa desde cero y aprendés a trabajar sin poner en riesgo tu vida ni la de tu familia. La base que nadie te enseñó y que vale oro.',
    value: '$8.900'
  }, {
    icon: '🔧',
    title: 'Tomo 2 — Reparaciones del Hogar',
    subtitle: 'Lo que te cobran un sueldo entero, lo resolvés en 15 minutos.',
    desc: 'Tomacorrientes, llaves de luz, empalmes e iluminación. Los arreglos más comunes de cualquier casa, paso a paso. Cada vez que lo apliques, estás ahorrando plata real de tu bolsillo.',
    value: '$8.900'
  }, {
    icon: '🗂️',
    title: 'Tomo 3 — Tableros y Protecciones',
    subtitle: 'Nunca más pagar una visita de emergencia a las 11 de la noche.',
    desc: 'Diagnosticás y resolvés cualquier problema del tablero vos mismo en minutos. Sin esperar al técnico, sin pagar una visita que te vacía el bolsillo justo cuando menos podés.',
    value: '$8.900'
  }, {
    icon: '🏗️',
    title: 'Tomo 4 — Instalaciones Profesionales',
    subtitle: 'Acá empieza el oficio. Acá empieza la plata.',
    desc: 'Aprendés a ejecutar instalaciones completas como un profesional. El conocimiento exacto para salir a presupuestar trabajos reales y empezar a cobrar por tu cuenta desde cero.',
    value: '$8.900'
  }, {
    icon: '📋',
    title: 'Tomo 5 — Nivel Técnico Avanzado',
    subtitle: 'El salto que separa al que sabe del que vive de esto.',
    desc: 'Normas, verificaciones y diagnósticos avanzados. Con este tomo ya podés trabajar en cualquier instalación con la seguridad y la autoridad de un técnico matriculado que cobra en serio.',
    value: '$8.900'
  }, {
    icon: '🤖',
    title: 'Tomo 6 — Domótica y Energía Solar',
    subtitle: 'El que sabe esto hoy, cobra el doble que el resto.',
    desc: 'Automatización inteligente y energía solar explicada sin tecnicismos. Los trabajos mejor pagados del mercado eléctrico actual, al alcance de tu mano desde el primer día.',
    value: '$8.900'
  }];
  return <section className="py-16 bg-gray-50 text-gray-900 overflow-hidden border-t border-gray-200" data-id="element-181">
      <div className="max-w-5xl mx-auto px-4" data-id="element-182">
        {/* Header */}
        <div className="text-center mb-10" data-id="element-183">
          <h2 className="text-[26px] md:text-4xl font-black text-gray-900 mb-4 leading-tight" data-id="element-184">
            6 Tomos que te llevan de no saber{' '}
            <span className="text-blue-600" data-id="element-185">
              tocar un cable a vivir del oficio.
            </span>
          </h2>
          <p className="text-gray-500 text-[13px] md:hidden" data-id="element-186">
            Deslizá para ver todos los tomos 👈
          </p>
        </div>
      </div>

      {/* Carrusel */}
      <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory px-4 pb-4 scrollbar-hide md:max-w-5xl md:mx-auto md:flex-wrap md:justify-center md:overflow-visible" data-id="element-187">
        {tomos.map((tomo, i) => <div key={i} className="min-w-[280px] max-w-[300px] md:min-w-0 md:w-[calc(33.333%-1rem)] snap-start bg-white rounded-2xl border border-gray-200 p-5 flex flex-col gap-3 shadow-sm hover:shadow-md transition-shadow" data-id="element-188">
            <div className="text-3xl" data-id="element-189">{tomo.icon}</div>
            <h3 className="text-lg font-bold text-gray-900 leading-snug" data-id="element-190">
              {tomo.title}
            </h3>
            <p className="text-sm font-semibold text-blue-600" data-id="element-191">
              {tomo.subtitle}
            </p>
            <p className="text-sm text-gray-600 leading-relaxed flex-1" data-id="element-192">
              {tomo.desc}
            </p>
            <p className="text-xs text-gray-400 mt-auto" data-id="element-193">
              Valor individual:{' '}
              <span className="line-through" data-id="element-194">{tomo.value}</span>
            </p>
          </div>)}
      </div>

      {/* CTA */}
      <div className="max-w-5xl mx-auto px-4 mt-10 text-center" data-id="element-195">
        <CTAButton href="#compra" text="⚡ QUIERO EL MEGAPACK" subtext="🔒 Pago seguro · Acceso inmediato · Garantía 30 días" data-id="element-196" />
      </div>
    </section>;
});